import styles from "./Summery.module.css";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Uniter } from "../../../../helbest";
import { toFixedNumber } from "../../../../base/utils";
import { useTranslation } from "react-i18next";

const Summery = (props) => {
  const { login, tax } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.Summery}>
      <div className={styles.RowItem}>
        <span>{t("summery.number_items")}</span>
        <span style={{ fontWeight: "bold" }}>
          {login.cart_data.total_quantity}
        </span>
      </div>

      <div className={styles.RowItem}>
        <span>{t("summery.price")}</span>
        <Uniter isBold>
          {toFixedNumber(login.cart_data.total_amount)}
        </Uniter>
      </div>

      {login.cart_data.discount_amount > 0 && (
        <div className={styles.RowItem}>
          <span>{t("summery.discount")}</span>

          <Uniter isBold>
            {toFixedNumber(login.cart_data.discount_amount)}
          </Uniter>
        </div>
      )}

      {tax && tax.amount > 0 && (
        <div className={styles.RowItem}>
          <span>{t("summary.tax")}</span>

          <Uniter isBold>
            {toFixedNumber(tax.amount)}
          </Uniter>
        </div>
      )}

      <div className={styles.Seprator}></div>

      <div className={styles.RowItem}>
        <span className={styles.TitleAmount}>{t("summery.payable")}</span>

        <Uniter isBold>
          {toFixedNumber(login.cart_data.payable_amount)}
        </Uniter>
      </div>
    </div>
  );
};

Summery.propTypes = {
  login: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    login: state.Login,
  };
};

export default connect(mapStateToProps)(Summery);
